function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHonda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 25,
    style: {
      fill: "black",
      font: "10px sans-serif"
    }
  }, "\n    HONDA\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonda);
export default __webpack_public_path__ + "static/media/honda.74a49130a3b1fd3228e4727dd0ccac85.svg";
export { ForwardRef as ReactComponent };